import { Amplify } from 'aws-amplify';
import runtimeConfig from './runtimeConfig';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: runtimeConfig.cognitoUserPoolId,
      userPoolClientId: runtimeConfig.cognitoAppClientId,
      region: runtimeConfig.cognitoRegion,
    },
  },
});
